/** Display labels only. Authored research tiers are already one-based. */
export function researchTierLabel(tier: number | null | undefined): string {
 return tier === null || tier === undefined || tier === 0 ? 'Base studies' : `Tier ${String(tier)}`;
}
/** Individually verified missing consumers, not a blanket hook judgment. */
export function inactiveResearchEffect(key: string): boolean {
 return key === 'ticket_price_tolerance_bp' || key === 'zoo_satisfaction_gain' || key === 'unlock_individual_tags' || key === 'census_accuracy_exact';
}
